import script from "./WarnList.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarnList.vue?vue&type=script&setup=true&lang=ts"

import "./WarnList.vue?vue&type=style&index=0&id=78d1806f&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d1806f"]])

export default __exports__